import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

// Material-UI Components
import { Box, Typography, IconButton } from "@mui/material";

// Material-UI Icons
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export default function EventCarousel(props) {
  const { slides } = props;
  const [carouselIndex, setCarouselIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setCarouselIndex(selectedIndex);
  };

  return (
    <>
      <Carousel
        activeIndex={carouselIndex}
        onSelect={handleSelect}
        interval={null}
        controls={true}
        touch={false}
        style={{ width: "100%" }}
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={index} style={{ marginBottom: "100px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                  xl: "row",
                },
                px: 2,
              }}
            >
              <img
                className={`carousel-image-${slide.title}-${index}`}
                src={slide.image}
                alt={`Slide ${index + 1}`}
                style={{
                  margin: "10px",
                  width: "100%",
                  height: "auto", // This ensures aspect ratio is maintained
                  maxWidth: "400px", // Restricts the max width to 400px
                  maxHeight: "400px", // Optionally restrict the max height to 400px if needed
                  objectFit: "contain", // Ensures the image fits within the container
                  transition: "transform 0.3s ease-in-out", // Smooth rotation
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "rotate(2deg)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "rotate(0deg)";
                }}
              />
              <Box sx={{ color: "white", maxWidth: "600px", px: 4, my: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h3
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      display: "inline-block",
                      backgroundColor: "white",
                      padding: "10px",
                      borderRadius: "16px",
                    }}
                  >
                    {slide.title}
                  </h3>

                  {slide.title === "WoC 7.0" ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <IconButton
                        sx={{
                          mr: 1,
                          width: 40, // Equal width
                          height: 40, // Equal height
                          borderRadius: "50%", // Makes it a perfect circle
                          bgcolor: "rgba(255, 255, 255, 0.1)",
                          "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
                        }}
                        onClick={() =>
                          window.open("https://chat.whatsapp.com/GP7lje21kXf6yRPqMuCVrg", "_blank")
                        }
                      >
                        <i
                          className="fa-brands fa-whatsapp"
                          style={{ color: "white" }}
                        ></i>
                      </IconButton>
                      <IconButton
                        sx={{
                          width: 40, // Equal width
                          height: 40, // Equal height
                          borderRadius: "50%", // Makes it a perfect circle
                          bgcolor: "rgba(255, 255, 255, 0.1)",
                          "&:hover": { bgcolor: "rgba(255, 255, 255, 0.2)" },
                        }}
                        onClick={() =>
                          window.open(
                            "https://www.youtube.com/playlist?list=PLGaIlwi1LuTBGMn9kXyqTwQ7iVX5XNjpx",
                            "_blank"
                          )
                        }
                      >
                        <i
                          className="fa-brands fa-youtube"
                          style={{ color: "white" }}
                        ></i>
                      </IconButton>
                    </Box>
                  ) : null}
                </Box>
                <Typography sx={{ my: 1 }}>{slide.description}</Typography>
                <Typography sx={{ my: 1 }} fontWeight="bold">
                  {slide.title.startsWith("Face Off") ? "Contests" : "Projects"}
                </Typography>
                {slide.projects && (
                  <Box
                    sx={{
                      my: 1,
                      bgcolor: {
                        xs: "transparent",
                        sm: "rgba(255, 255, 255, 0.05)",
                        md: "rgba(255, 255, 255, 0.05)",
                        lg: "rgba(255, 255, 255, 0.05)",
                        xl: "rgba(255, 255, 255, 0.05)",
                      },
                      borderRadius: 3,
                      p: 1,
                    }}
                  >
                    <ul>
                      {slide.projects.map((project, idx) => (
                        <li
                          key={idx}
                          style={{ position: "relative" }}
                          id="project-list-item"
                          onMouseEnter={() => {
                            const ele = document.getElementsByClassName(
                              `open-in-new-tab-icon-${slide.title}-${idx}`
                            );
                            if (ele.length > 0)
                              ele[0].style.visibility = "visible";
                          }}
                          onMouseLeave={() => {
                            const ele = document.getElementsByClassName(
                              `open-in-new-tab-icon-${slide.title}-${idx}`
                            );
                            if (ele.length > 0)
                              ele[0].style.visibility = "hidden";
                          }}
                        >
                          {project.link === "#" ? (
                            <Typography> {project.name}</Typography>
                          ) : (
                            <a
                              href={project.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "white",
                                textDecoration: "none",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.textDecoration =
                                  "underline")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.textDecoration = "none")
                              }
                            >
                              {project.name}
                            </a>
                          )}
                          {project.link === "#" ? null : (
                            <OpenInNewRoundedIcon
                              className={`open-in-new-tab-icon-${slide.title}-${idx}`}
                              fontSize="small"
                              sx={{
                                ml: 1,
                                position: {
                                  xs: "absolute",
                                  sm: "absolute",
                                  md: "relative",
                                  lg: "relative",
                                  xl: "relative",
                                },
                                top: 0,
                                right: 0,
                                transform: {
                                  xs: "translateX(100%)",
                                  sm: "translateX(100%)",
                                  md: "translateX(0%)",
                                  lg: "translateX(0%)",
                                  xl: "translateX(0%)",
                                },
                                visibility: "hidden",
                              }}
                            />
                          )}
                        </li>
                      ))}
                    </ul>
                  </Box>
                )}
              </Box>
            </Box>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
}
